<template>
    <div v-if="!appNotAvailable">
        <!-- 2022.01.14 以下是重构的登录界面 -->
        <h5-dialog v-if="!isNativeJingYouLogin">
            <div
                class="text-center w-100"
                @click="handleTitleClick"
                style="margin-bottom:10px;font-size:18px;"
            >
                {{ $t('账号登录') }}
            </div>
            <div class="form">
                <div style="margin-bottom:5px;">
                    <h5-input v-model="loginForm.account" :placeholder="$t('请输入账号或邮箱')" :disabled="appNotAvailable">
                        <template v-slot:prepend>
                            <i class="fa fa-user-o" style="font-size:16px;color:#f9dda0;" />
                        </template>
                        <template v-slot:append v-if="localAccountList.length">
                            <i
                                class="fa"
                                :class="[accountListPopupVisible ? 'fa-angle-up' : 'fa-angle-down']"
                                @click="toggleAccountListPopup"
                            />
                        </template>
                    </h5-input>
                </div>
                <div style="margin-bottom:8px;">
                    <h5-input
                        v-model="loginForm.password"
                        :placeholder="$t('请输入密码')"
                        :disabled="appNotAvailable"
                        :type="passwordVisible ? 'text' : 'password'"
                    >
                        <template v-slot:prepend>
                            <i class="fa fa-lock" style="font-size:18px;color:#f9dda0;" />
                        </template>
                        <template v-slot:append>
                            <i
                                class="fa password-visible-icon"
                                :class="[passwordVisible ? 'fa-eye' : 'fa-eye-slash']"
                                @click="passwordVisible = !passwordVisible"
                            />
                        </template>
                    </h5-input>
                </div>
                <div class="to-center">
                    <label class="flex-row flex-center">
                        <small class="text-center">
                            <span style="color:#999;font-size:12px;" v-if="isShowPrivacy">
                                《
                                <a style="text-decoration:underline;" @click="showUserAgreement = true">{{ $t('隐私协议') }}</a>
                                》
                            </span>
                            <span style="color:#999;font-size:12px;margin-left:6px;" v-if="isShowTermsOfService">
                                《
                                <a style="text-decoration:underline;" @click="showTermsOfService = true">{{ $t('服务条款') }}</a>
                                》
                            </span>
                            <router-link
                                :disabled="appNotAvailable"
                                :event="appNotAvailable ? '' : 'click'"
                                :to="{
                                path: '/resetPassword',
                                query: $route.query
                            }">
                                <span style="color:#fb6029;white-space:nowrap;">{{ $t('忘记密码') }}</span>
                            </router-link>
                        </small>
                    </label>
                </div>
            </div>
            <button
                class="btn btn-block btn-primary m-b"
                @click="startLogin"
                :disabled="appNotAvailable"
                style="border-radius:18px;margin-top:8px;"
            >
                {{ $t('登录') }}
            </button>
            <van-row>
                <van-col span="12" class="to-center">
                    <router-link
                        :to="{
                        path: '/register',
                        query: {
                            ...$route.query,
                            reg_type: 'mobile',
                        }}"
                        :disabled="appNotAvailable"
                        class="bottom-button"
                    >
                        {{ $t('邮箱登录') }}
                    </router-link>
                </van-col>
                <van-col span="12" class="to-center">
                    <router-link
                        :to="{
                        path: '/register',
                        query: {
                            ...$route.query,
                            reg_type: 'account',
                        }}"
                        :disabled="appNotAvailable"
                        class="bottom-button"
                    >
                        {{ $t('账号注册') }}
                    </router-link>
                </van-col>
            </van-row>

            <div v-if="isShowGoogleLogin">
                <div class="empty-element" />

                <div id="g_id_onload"
                    data-client_id="799433220452-qb54b5us8joeusrb62cvqlf2hnf469eb.apps.googleusercontent.com"
                    data-callback="handleCredentialResponse"
                    data-context="signin">
                </div>

                <div class="g_id_signin"
                    data-type="standard"
                    data-shape="rectangular"
                    data-theme="outline"
                    data-text="signin_with"
                    data-size="large">
                </div>
            </div>

            <div class="oversea">
                <!-- <div class="facebook" @click="loginWithFacebook">
                    <i class="fa fa-facebook-square" style="font-size:22px;color:#3975ea;" />
                    <span>Login</span>
                </div> -->
                <div class="google" @click="loginWithGoogle" v-if="showGoogleLoginByAndroid">
                    <i class="fa fa-google" style="font-size:22px;color:#d14e3d;" />
                    <span>Login</span>
                </div>
            </div>
            <div class="serviceQQ bottom-button">
                <span @click="serviceActivated = true">
                    {{ $t('联系客服') }}
                </span>
            </div>
        </h5-dialog>


        <!-- 用户协议组件 -->
        <user-agreement v-if="showUserAgreement" @agree="handleAgree" />

        <!-- 服务条款组件（game_id=1123039 / 1123038 显示入口） -->
        <terms-of-service v-if="showTermsOfService" @close="showTermsOfService = false" />


        <!-- 2022.01.14 以下原有弹框逻辑保持不变 -->
        <popup
            v-model="accountListPopupVisible"
            position="bottom"
        >
            <picker
                :title="$t('本地账号')"
                show-toolbar
                :columns="localAccountList"
                value-key="account"
                @cancel="toggleAccountListPopup"
                @confirm="handlePickAccount"
            ></picker>
        </popup>

        <van-dialog
            v-model="showAccountDetail"
            :title="$t('账号已生成，注意保存')"
            @confirm="redirectGame"
        >
            <div class="text-center">
                <div class="m-b text-center">
                    <h5>{{ $t('账号') }}：{{ loginForm.account }}</h5>
                    <h5>{{ $t('密码') }}：{{ loginForm.password }}</h5>
                </div>
            </div>
        </van-dialog>

        <bind-id-card
            :closable="bindIDCardClosable"
            :loginOutable="bindIDCardLoginOutable"
            v-if="showBindIDCard"
            @close="onBindIDClose"
            @bind-success="onBindIDSuccess"
            @close-bind-id-modal="closeBindIDModal"
        ></bind-id-card>

        <van-dialog
            v-model="showLoading"
            @confirm="closeLoading"
            theme='round-button'
            :confirmButtonText="$t('切换账号')"
            confirmButtonColor='#f99e00'
            width='150px'
        >
            <van-loading
                vertical
                size="24px"
                style="margin-top:10px;"
            >
            {{ $t('自动登录中') }}...
            </van-loading>
        </van-dialog>

        <van-dialog
            v-model="serviceActivated"
            :title="$t('联系客服')"
        >
            <div class="text-center">
                <div class="m-b text-center">
                    <div class="m-b-sm">
                        If you have any questions, please contact our customer service email, and we will get back to you as soon as possible.
                    </div>
                    <h3>Email: xhskyxgs@gmail.com</h3>
                </div>
            </div>
        </van-dialog>

        <!-- <van-dialog
            v-model="serviceActivated"
            :title="serviceData.title || $t('联系客服')"
            show-cancel-button
            :cancel-button-text="$t('关闭')"
            :confirm-button-text="$t('立即联系')"
            @confirm="addServiceQQ"
        >
            <div class="text-center">
                <div class="m-b text-center">
                    <div class="m-b-sm" v-show="serviceData.describe">{{ serviceData.describe }}</div>
                    <div class="m-b-sm" v-show="serviceData.title">{{ serviceData.title }}</div>
                    <h3 v-show="serviceData.qq">QQ：{{ serviceData.qq }}</h3>
                    <h3 v-show="serviceData.phone">{{ $t('邮箱') }}：{{ serviceData.phone }}</h3>
                    <small>{{ $t('时间') }}：{{ serviceData.service_time || '-' }}</small>
                    <h5>({{ $t('点击“立即联系”无反应，请手动添加QQ') }})</h5>
                </div>
            </div>
        </van-dialog> -->
    </div>
</template>

<script>
import H5Dialog from '@/components/H5Dialog'
import H5Input from '@/components/H5Input'
import verifyIDMixin from '@/mixins/verifyID.mixin'
import { Dialog as VanDialog, Dialog, Picker, Popup, Row, Col } from 'vant'
import { getAccounts, getLastLoginAccount, setAccounts, setLastLoginAccount, getLocalAccountData,setLocalAccountData } from '@/utils/storage'
import { mapState } from 'vuex'
import { getLocalAppConfig } from '@/utils/storage'
import browser from '@/utils/browser'
import { $t } from '@/utils/languages'
// import { baseApiURL } from '@/utils/properties'
// import { combineURLs } from '@/utils/url'

export default {
    name: 'Login',
    mixins: [verifyIDMixin],
    components: {
        H5Input,
        H5Dialog,
        Popup,
        Picker,
        VanDialog: VanDialog.Component,
        // VanCheckbox: Checkbox,
        VanRow: Row,
        VanCol: Col,
        UserAgreement: () => import(/* webpackChunkName: 'UserAgreement' */'../components/UserAgreement'),
        TermsOfService: () => import(/* webpackChunkName: 'TermsOfService' */'../components/terms/TermsOfService'),
    },
    data() {
        return {
            accountListPopupVisible: false,
            passwordVisible: false,
            showAccountDetail: false,
            loginForm: {
                account: '',
                password: '',
                mobile: '',
                code: '',
            },
            logining: false,
            clickCount:0,
            showLoading: false,
            loginTimer: null,
            agreed: browser.isAndroid ? false : true, // 2022.07.25 安卓默认不同意，其他默认同意
            showUserAgreement: false, // 是否显示用户协议
            showTermsOfService: false, // 是否显示服务条款
            serviceActivated: false,
        }
    },
    computed: {
        localAccountList() {
            return getAccounts()
        },
        ...mapState({
            appConfig: state => state.app.appConfig,
            gameConfig: state => state.app.gameConfig,
            accountData: state => state.accountData,
            firstOpen: state => state.firstOpen,
            serviceData: state => state.serviceInfo,
        }),
        appNotAvailable() {
            // 当地址与本地保存的appConfig重的game_id均为非法值时不允许执行操作
            return !this.appConfig.game_id
        },
        isShowPrivacy() {
            return ['1123005', '1123023', '1123026', '1123038', '1123039'].includes(`${this.appConfig.game_id}`)
        },
        isShowTermsOfService() {
            // 服务条款对 game_id=1123039（34包）和 game_id=1123038（谷歌6包）展示
            return ['1123038', '1123039'].includes(`${this.appConfig.game_id}`)
        },
        isShowGoogleLogin() {
            return ['1123001'].includes(`${this.appConfig.game_id}`)
        },
        showGoogleLoginByAndroid() {
            return window?.JsJingYouNativeBridge?.nativeLoginOfGoogle instanceof Function
        },
        isNativeJingYouLogin() {
            // 2026.6.6 链接参数is_native为1，走安卓原生登录
            return this.$route?.query?.is_native == '1' && browser.isAndroid
            // return window?.JsJingYouNativeBridge?.nativeJingYouLogin instanceof Function
        },
    },
    methods: {
        checkLoginState() {
            window.FB.getLoginStatus((response) => {
                this.statusChangeCallback(response);
            });
        },
        statusChangeCallback(response) {
            if (response.status === 'connected') {
                // 用户已登录且已授权你的应用
                this.testAPI();
            } else {
                // 用户未登录或未授权你的应用
                // console.log('Please log into this app.');
            }
        },
        testAPI() {
            window.FB.api('/me', (response) => {
                // console.log('Successful login for: ' + response.name);
            });
        },
        loginWithFacebook() {
            window.FB.login((response) => {
                if (response.authResponse) {
                    console.log('>>>> FB accessToken', response.authResponse.accessToken)
                    // console.log('Welcome!  Fetching your information.... ');
                    window.FB.api('/me', (response) => {
                        // console.log('Good to see you, ' + response.name + '.');
                    });
                } else {
                    // console.log('User cancelled login or did not fully authorize.');
                }
            }, { scope: 'email' });
        },
        getLastLoginAccount() {
            let lastLoginAccount = getLastLoginAccount()
            if (lastLoginAccount.account) {
                this.loginForm.account = lastLoginAccount.account
                this.loginForm.password = lastLoginAccount.password
            }
        },
        startLogin() {
            let { appConfig } = this

            // 校验
            if (!this.loginForm.account) {
                this.$toast($t('请输入账号或邮箱'))
                return false
            }
            if (!this.loginForm.password) {
                this.$toast($t('请输入密码'))
                return false
            }
            // if (!this.agreed) {
            //     this.$toast('请阅读并同意用户协议及隐私政策')
            //     return false
            // }

            // if (this.loginForm.account === '') {
            //     this.$toast('请输入账号或邮箱号码')
            //     return false
            // } else if (this.loginForm.password === '') {
            //     this.$toast('请输入密码')
            //     return false
            // }
            if (!this.logining) {
                this.logining = true
                this.$toast.loading({
                    message: `${$t('登录中')}...`,
                    // message: `登录中...`,
                    forbidClick: true,
                    duration: 0,
                })
                let loginData = {
                    platform: appConfig.platform,
                    muid: appConfig.muid,
                    game_id: appConfig.game_id,
                    username: this.loginForm.account,
                    reg_time: '',
                    user_sign: this.loginForm.account,
                    password: this.loginForm.password,
                    check_type: 1,
                    reg_type: '',
                }
                this.$store.dispatch('userLogin', loginData).then(res => {
                    if (Number(res.code) === 0) {
                        this.$toast.clear()
                        this.handleLoginSuccess(res).then(() => {
                            // if(res.data.anti_time === 0){
                            //     this.$dialog.alert({
                            //         title: '提示',
                            //         message: `${res.data.anti_msg}`,
                            //         confirmButtonText: '确定',
                            //     })
                            // }else{
                                this.$toast.success($t('登录成功'))
                                this.redirectGame()
                            // }
                        })
                        // this.saveAccount({
                        //     account: this.loginForm.account,
                        //     password: this.loginForm.password,
                        // })
                        // this.$store.dispatch('saveAccountData', {
                        //     ...res.data,
                        // }).then(() => {
                        //     console.log('create frame')
                        //     this.redirectGame()
                        // })
                    } else {
                        this.$toast(res.msg || $t('登录失败'))
                    }
                }).finally(() => {
                    this.logining = false
                })
            }
        },
        startTokenLogin() {
            let { appConfig } = this
            const localAccountData = getLocalAccountData();
            const { user_token } = localAccountData;

            if (user_token && !this.logining) {
                this.logining = true
                this.showLoading = true;
                clearTimeout(this.loginTimer)
                this.loginTimer = setTimeout(()=>{
                    let loginData = {
                        game_id: appConfig.game_id,
                        token: user_token,
                    }
                    this.$store.dispatch('tokenLogin', loginData).then(res => {
                        if (Number(res.code) === 0) {
                            this.$toast.clear()
                            this.handleLoginSuccess(res).then(() => {
                                // if(res.data.anti_time === 0){
                                //     this.$dialog.alert({
                                //         title: '提示',
                                //         message: `${res.data.anti_msg}`,
                                //         confirmButtonText: '确定',
                                //     })
                                // }else{
                                    this.$toast.success($t('登录成功'))
                                    this.redirectGame()
                                // }
                            })
                        } else {
                            setLocalAccountData({})
                            this.$toast(res.msg || $t('登录失败'))
                        }
                    }).finally(() => {
                        this.logining = false;
                        this.showLoading = false;
                    })
                },3000)
            }
        },
        closeLoading() {
            clearTimeout(this.loginTimer);
            this.showLoading = false;
            this.logining = false;
            window.postMessage({ key: 'reLogin', value: true }, '*')

            // 2022.04.11 回传切换账号事件给安卓端
            try {
                window?.JHJsImpl?.onLogout()
                console.log('JHJsImpl.onLogout<Android> | >>> ')
            } catch (err) {
                console.log('回传安卓端失败：', err)
            }
        },
        saveAccount(account) {
            let accounts = {}
            this.localAccountList.forEach(item => {
                accounts[item.account] = item
            })
            accounts[account.account] = account
            setAccounts(Object.values(accounts))
        },
        redirectGame() {
            this.$store.dispatch('checkGameUrl') // 2022.05.18 先检测新旧用户，再创建游戏
        },
        toggleAccountListPopup() {
            this.accountListPopupVisible = !this.accountListPopupVisible
        },
        handlePickAccount(value) {
            this.loginForm.account = value.account
            this.loginForm.password = value.password
            this.toggleAccountListPopup()
        },
        async oneKeyReg() {
            const retryTimes = 3 // 210316 一键注册重试三次仍然失败再提示用户注册失败
            let totalTryTimes = 0 // 尝试一键注册次数
            this.$toast.loading({
                message: `${$t('登录中')}...`,
                closeOnClick: false,
                duration: 0,
            })
            const reg = async () => {
                totalTryTimes += 1
                const randomAccount = await this.$store.dispatch('generateAccount')
                this.loginForm = {
                    ...this.loginForm,
                    ...randomAccount,
                }
                const result = await this.$store.dispatch('userRegister', {
                    check_type: 3,
                    username: this.loginForm.account,
                    password: this.loginForm.password,
                    reg_type: undefined,
                })
                if (Number(result.code) === 0) {
                    // this.saveAccount({
                    //     account: this.loginForm.account,
                    //     password: this.loginForm.password,
                    // })
                    // this.$store.dispatch('saveAccountData', {
                    //     ...res.data,
                    // })
                    this.$toast.clear()
                    this.handleLoginSuccess(result).then(() => {
                        this.passwordVisible = true

                        // 2022.01.14 暂不展示提示保存账号密码弹框
                        // this.showAccountDetail = true
                    })
                } else {
                    if (totalTryTimes < retryTimes) {
                        await reg()
                    } else {
                        this.$toast.clear()
                        this.$toast.fail(result.msg || $t('登录失败'))
                    }
                }
            }
            await reg()
        },
        handleLoginSuccess(res) {
            const accountData = {
                account: this.loginForm.account,
                password: this.loginForm.password,
            }
            this.saveAccount(accountData)
            setLastLoginAccount(accountData)
            this.postAndroidLoginSuccess({ ...res.data })
            return this.$store.dispatch('saveAccountData', {
                ...res.data,
            }).then(() => {
                return this.updateVerifyInfo(res).then(() => {
                    const accountData = {
                        account: this.loginForm.account,
                        password: this.loginForm.password,
                    }
                    this.saveAccount(accountData)
                    setLastLoginAccount(accountData)
                    return this.$store.dispatch('saveAccountData', {
                        ...res.data,
                        ...accountData,
                    })
                }).catch(() => {
                    this.$toast('实名认证失败，请重试')
                    return Promise.reject({
                        msg: '实名认证失败',
                    })
                })
            })
        },
        postAndroidLoginSuccess(prm) {
            try {
                // 2025.05.09 回传新安卓壳包登录信息
                const params = JSON.stringify({
                    userName: prm.username ?? '',
                    user_token: prm.user_token ?? '',
                })
                window?.JsJingYouNativeBridge?.loginSuccess?.(params)
                console.log('JsJingYouNativeBridge.loginSuccess<Android> | loginSuccess >>> ', params)
            } catch (err) {
                console.error('>>> post Android loginSuccess fail', err)
            }
        },
        handleTitleClick() {
            if (this.clickCount > 10) {
                if (window.openVConsole !== undefined) {
                    window.openVConsole()
                    alert('open console manually')
                    console.log('open console manually')
                }
            } else {
                this.clickCount += 1
            }
        },
        // 点击用户协议
        handleAgree() {
            this.agreed = true
            this.showUserAgreement = false
        },
        // 用户第一次注册时，自动生成账号密码
        async autoGoRegister() {
            // 生成随机账号
            const randomAccount = await this.$store.dispatch('generateAccount')
            this.$store.commit('app/UPDATE_ACCOUNT_FIRST', randomAccount?.account || '')
            this.$store.commit('app/UPDATE_PASSWORD_FIRST', randomAccount?.password || '')

            // 自动注册账号，并跳转到注册页面
            this.$router.push({
                path: '/register',
                query: {
                    ...(this.$route.query ? { ...this.$route.query } : {}),
                    reg_type: 'account'
                }
            })
        },
        // 加客服qq
        addServiceQQ() {
            const groupLink = this.serviceData.qq_url
            this.$dialog({ title: $t('正在尝试跳转QQ') })
            // 2022.05.27 iOS新壳包跳转方式（game_id: 1112004）
            if (window?.webkit?.messageHandlers?.ios_jumpstore?.postMessage) {
                window.webkit.messageHandlers.ios_jumpstore.postMessage(groupLink)
            } else {
                const tempFrame = document.createElement('iframe')
                tempFrame.setAttribute('frameborder', '0')
                tempFrame.setAttribute('src', groupLink)
                tempFrame.setAttribute('style', 'visibility: hidden;z-index: 0')
                tempFrame.onload = () => {
                    setTimeout(() => {
                        document.body.removeChild(tempFrame)
                        Dialog.close()
                    }, 2000)
                }
                tempFrame.onerror = () => {}
                document.body.appendChild(tempFrame)
            }
        },
        // 动态加载Google登录脚本
        loadGoogleScript() {
            const script = document.createElement('script');
            script.src = 'https://accounts.google.com/gsi/client';
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
        },
        handleCredentialResponse(response) {
            console.log('>>> google response', response)
            let { appConfig } = this
            if (!this.logining) {
                this.logining = true
                this.$toast.loading({
                    message: `${$t('登录中')}...`,
                    forbidClick: true,
                    duration: 0,
                })
                let loginData = {
                    access_token: response?.credential,
                    game_id: appConfig.game_id,
                }
                this.$store.dispatch('googleLogin', loginData).then(res => {
                    if (Number(res.code) === 0) {
                        this.$toast.clear()
                        this.handleLoginSuccess(res).then(() => {
                            this.$toast.success($t('登录成功'))
                            this.redirectGame()
                        })
                    } else {
                        this.$toast(res.msg || $t('登录失败'))
                    }
                }).finally(() => {
                    this.logining = false
                })
            }
        },
        // 安卓壳包谷歌登录
        loginWithGoogle() {
            // 拉起安卓壳包的谷歌登录
            try {
                window?.JsJingYouNativeBridge?.nativeLoginOfGoogle?.()
                console.log('JsJingYouNativeBridge.nativeLoginOfGoogle<Android> | nativeLoginOfGoogle >>> ')
            } catch (err) {
                console.error('>>> post Android nativeLoginOfGoogle fail', err)
            }
        },
        /** 安卓壳包，点H5谷歌登录图标按钮登录 */
        googleLoginByJhSdk(credential) {
            console.log('>>> google credential', credential)
            let { appConfig } = this
            if (credential && !this.logining) {
                this.logining = true
                this.$toast.loading({
                    message: `${$t('登录中')}...`,
                    forbidClick: true,
                    duration: 0,
                })
                let loginData = {
                    access_token: credential,
                    game_id: appConfig.game_id,
                }
                this.$store.dispatch('googleLogin', loginData).then(res => {
                    if (Number(res.code) === 0) {
                        this.$toast.clear()
                        this.handleLoginSuccess(res).then(() => {
                            this.$toast.success($t('登录成功'))
                            this.redirectGame()
                        })
                    } else {
                        this.$toast(res.msg || $t('登录失败'))
                    }
                }).finally(() => {
                    this.logining = false
                })
            }
        },
        /** 安卓壳包，安卓原生登录弹窗 */
        loginCallbackByAndroid(res) {
            console.log('>>> loginCallbackByAndroid res', res)
            const resInfo = { data: {} }
            try {
                resInfo.data = JSON.parse(res)
            } catch (err) {
                console.error('>>> loginCallbackByAndroid parse error', err)
                this.$toast($t('登录失败'))
                return
            }
            this.handleLoginSuccess(resInfo).then(() => {
                this.$toast.success($t('登录成功'))
                this.redirectGame()
            })
        },
    },
    activated() {
        this.getLastLoginAccount()
    },
    mounted() {
        if (this.isShowGoogleLogin) {
            this.loadGoogleScript()
            window.handleCredentialResponse = this.handleCredentialResponse
        }
        window.googleLoginByJhSdk = this.googleLoginByJhSdk // 安卓壳包谷歌登录成功后触发
        window.loginCallbackByAndroid = this.loginCallbackByAndroid // 安卓壳包Token登录成功后触发
        this.getLastLoginAccount()

        // 2025.12.11 使用安卓壳包原生登录弹窗
        if (this.isNativeJingYouLogin) {
            try {
                window?.JsJingYouNativeBridge?.nativeJingYouLogin?.()
            } catch (err) {
                console.error('>>> call nativeJingYouLogin fail', err)
            }
            return
        }

        if(this.firstOpen){
            this.$store.dispatch("updateFirstOpen",false)
            this.startTokenLogin();

            const localAppConfig = getLocalAppConfig()
            // 没有登录账号，并且游戏id存在时，自动注册
            if (!this.loginForm.account && localAppConfig?.game_id) {
                this.autoGoRegister()
            }
        }


        // 加载 Facebook SDK
        // (function (d, s, id) {
        //     var js, fjs = d.getElementsByTagName(s)[0];
        //     if (d.getElementById(id)) return;
        //     js = d.createElement(s);
        //     js.id = id;
        //     js.src = "https://connect.facebook.net/en_US/sdk.js";
        //     fjs.parentNode.insertBefore(js, fjs);
        // }(document, 'script', 'facebook-jssdk'));

        // window.fbAsyncInit = () => {
        //     console.log('>>> window.FB.init', window.FB)
        //     window.FB.init({
        //         appId: 'YOUR_APP_ID', // 应用 ID
        //         cookie: true,
        //         xfbml: true,
        //         version: 'v18.0'
        //     });
        //     // 初始化后检查登录状态
        //     window.FB.getLoginStatus((response) => {
        //         this.statusChangeCallback(response);
        //     });
        // };
    },
}
</script>

<style lang="scss" scoped>
.mobile-login-btn, .mobile-login-btn:focus {
    background-color: $blue !important;
    color: $white;
}

.serviceQQ {
    text-align: center;
    font-size: 14px;
    margin: 12px 0;
    cursor: pointer;
}

.oversea {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 18vw;
    margin-top: 6px;
    .facebook {
        display: inline-block;
        font-size: 16px;
        font-weight: bold;
        color: #3975ea;
        span {
            margin-left: 4px;
        }
    }
    .google {
        display: inline-block;
        font-size: 16px;
        font-weight: bold;
        color: #d14e3d;
        span {
            margin-left: 4px;
        }
    }
}

.empty-element {
    height: 16px;
}
</style>
